import {
  setAuthStandaloneAdapter,
  useAuthProfileAdapter,
} from '@xstudios/xapp-auth'
import perm from '@xstudios/xapp-auth/directives/perm'
import { useRuntimeAuthStore } from '@xstudios/xapp-auth/stores/runtimeAuthStore'
import { registerFileEditorAceAssets } from '@xstudios/xapp-core/foundation/ace/fileEditorAce'
import { setXappCoreAuthAdapter } from '@xstudios/xapp-core/foundation/adapters/auth'
import { setXappCoreIdentityAdapter } from '@xstudios/xapp-core/foundation/adapters/identity'
import { setXappCoreMqttAdapter } from '@xstudios/xapp-core/foundation/adapters/mqtt'
import { setXappCoreMqttTesterAdapter } from '@xstudios/xapp-core/foundation/adapters/mqttTester'
import { setXappCoreConstants } from '@xstudios/xapp-core/foundation/config/appConstants'
import { setXappCoreAppMeta } from '@xstudios/xapp-core/foundation/config/appMeta'
import { createXappVuetify } from '@xstudios/xapp-core/foundation/plugins'
import {
  setLegacyMqttSupportEnabled,
  useMqttClientStore,
  useMqttClientTesterStore,
} from '@xstudios/xapp-core/mqtt'
import { StandaloneLayout } from '@xstudios/xapp-core/shell'
import { createApp } from 'vue'

import {
  BROKER_URL,
  MQTT_BASE_TOPIC,
  MQTT_OPTIONS,
} from '@/config/appConstants'
import {
  APP_AUTHOR,
  APP_ISSUES_URL,
  APP_LICENSE,
  APP_NAME,
  APP_VERSION,
} from '@/config/appMeta'
import { BOTTOM_NAV_OPTIONS, SIDE_NAV_OPTIONS } from '@/config/navigation'
import { registerGlobalAuthPolicy } from '@/domains/integrations/services/registerGlobalAuthPolicy'
import router from '@/router'
import pinia from '@/stores'

import App from './App.vue'

import 'unfonts.css'
import '@xstudios/xapp-core/shell/styles/settings.scss'

registerFileEditorAceAssets()

const app = createApp(App)
const vuetify = createXappVuetify()
app.use(pinia)
app.use(vuetify)
app.use(router)

const authStore = useRuntimeAuthStore()
const mqttStore = useMqttClientStore()
const mqttTesterStore = useMqttClientTesterStore()

registerGlobalAuthPolicy()
setAuthStandaloneAdapter(StandaloneLayout)
setXappCoreAuthAdapter(authStore)
setXappCoreIdentityAdapter(useAuthProfileAdapter())
setXappCoreMqttAdapter(mqttStore)
setXappCoreMqttTesterAdapter(mqttTesterStore)
setLegacyMqttSupportEnabled(true)

setXappCoreAppMeta({
  APP_AUTHOR,
  APP_ISSUES_URL,
  APP_LICENSE,
  APP_NAME,
  APP_VERSION,
})

setXappCoreConstants({
  BOTTOM_NAV_OPTIONS,
  MQTT_BASE_TOPIC,
  MQTT_OPTIONS,
  SIDE_NAV_OPTIONS,
})

// Create a single sticky MQTT connection for the app lifecycle.
mqttStore.connectPersistent(BROKER_URL, {
  password: import.meta.env.VITE_MQTT_PASSWORD,
  username: import.meta.env.VITE_MQTT_USERNAME,
})
mqttStore.setDebug(false)

authStore.bootstrap().finally(() => {
  app.directive('perm', perm)
  app.mount('#app')
})
